<template>
  <div class="btns fixed-bar" v-if="device.visit">
    <el-row class="btn" v-if="device.visit.inspection_status !== 'archive'">
      <el-button
          type="primary"
          @click="closeVisit(false)"
          :loading="loading"
      >Сохранить
      </el-button>
      <el-button
          type="warning"
          @click="closeVisit(false)"
          :loading="loading"
      >Сохранить черновик
      </el-button>
      <el-button @click="confirmSave()" :loading="loading">Закрыть без изменений</el-button>
    </el-row>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "CloseBtns",
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters("visit", {device: "getDevices"}),
    visit() {
      return this.$route.params.visit;
    },
  },
  methods: {
    ...mapActions({
      setVisit: "visit/SET_DATA",
    }),
    confirmSave() {
      this.$confirm('Отправить данные пользователю?')
          .then(() => {
            this.closeVisit(true)
          })
    },
    closeVisit(save = false) {

      let params = {
        params: {
          send: save,
        },
      }

      this.loading = true;
      this.$api.visit
          .close(this.visit.id, save ? params : {})
          .then(() => {
            this.$notify.success({
              title: save ? "Визит закрыт" : "Черновик сохранен",
            })

            this.setVisit()

            this.$router.push({
              name: "visit.list",
            })

          })
          .catch((res) => {
            this.$notify.error({
              title: "Упс..",
              message: res.response.data.message,
            });
          })
          .finally(() => {
            this.loading = !!0
          })
    },
  }

}

</script>

<style lang="scss" scoped>
.fixed-bar {
  position: sticky;
  bottom: -20px;

  z-index: 2001;

  padding: 10px 0;
  border-radius: 0;

  width: 100%;
  background: #f6f8f9 !important;
}
.el-button--warning {
  background-color: #FFC107;
  border-color: #FFC107;

  color: #111;
}
</style>